<form [formGroup]="officeHoursForm">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <span class="font-semibold">Office Hours</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="flex flex-col gap-2 pt-2">
        <div class="flex flex-col md:flex-row gap-2">
          <mat-form-field class="md:w-1/7">
            <mat-label>Sun</mat-label>
            <input matInput formControlName="sunday">
            <mat-error *ngIf="officeHoursForm.get('sunday')?.invalid">
              If Closed Enter N/A
            </mat-error>
          </mat-form-field>
          <mat-form-field class="md:w-1/7">
            <mat-label>Mon</mat-label>
            <input matInput formControlName="monday">
            <mat-error *ngIf="officeHoursForm.get('monday')?.invalid">
              If Closed Enter N/A
            </mat-error>
          </mat-form-field>
          <mat-form-field class="md:w-1/7">
            <mat-label>Tues</mat-label>
            <input matInput formControlName="tuesday">
            <mat-error *ngIf="officeHoursForm.get('tuesday')?.invalid">
              If Closed Enter N/A
            </mat-error>
          </mat-form-field>
          <mat-form-field class="md:w-1/7">
            <mat-label>Wed</mat-label>
            <input matInput formControlName="wednesday">
            <mat-error *ngIf="officeHoursForm.get('wednesday')?.invalid">
              If Closed Enter N/A
            </mat-error>
          </mat-form-field>
          <mat-form-field class="md:w-1/7">
            <mat-label>Thurs</mat-label>
            <input matInput formControlName="thursday">
            <mat-error *ngIf="officeHoursForm.get('thursday')?.invalid">
              If Closed Enter N/A
            </mat-error>
          </mat-form-field>
          <mat-form-field class="md:w-1/7">
            <mat-label>Fri</mat-label>
            <input matInput formControlName="friday">
            <mat-error *ngIf="officeHoursForm.get('friday')?.invalid">
              If Closed Enter N/A
            </mat-error>
          </mat-form-field>
          <mat-form-field class="md:w-1/7">
            <mat-label>Sat</mat-label>
            <input matInput formControlName="saturday">
            <mat-error *ngIf="officeHoursForm.get('saturday')?.invalid">
              If Closed Enter N/A
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</form>
